import LocalStorageUtil from '@/utils/LocalStorageUtil'
import {nanoid} from "nanoid";

class AiAuthUtil {
    static _tokenKey: string = 'ai-token'
    static _clientIdKey: string = 'ai-client-id'

    /**
     * @returns {string}
     */
    static getToken(): string {
        return LocalStorageUtil.getItem(this._tokenKey)
    }

    static getClientId(): string {
        return LocalStorageUtil.getItem(this._clientIdKey)
    }

    static getTokenWithBearerPrefix(): string | null {
        const token = AiAuthUtil.getToken()
        if (!token) {
            return null;
        }
        return `Bearer ${token}`
    }

    static setToken(data: string) {
        LocalStorageUtil.setItem(this._tokenKey, data)
    }

    static setClientId(data: string) {
        LocalStorageUtil.setItem(this._clientIdKey, data)
    }

    static initClientId() {
        if (AiAuthUtil.getClientId()) {
            return;
        }

        const clientId = AiAuthUtil.generateClientId();
        LocalStorageUtil.setItem(this._clientIdKey, clientId)
    }

    static removeToken() {
        LocalStorageUtil.removeItem(this._tokenKey)
    }

    static removeAuth() {
        this.removeToken()
    }

    static generateClientId(): string {
        // return URL.createObjectURL(new Blob()).substr(-36);
        return nanoid()
    }
}

export default AiAuthUtil